import { render, staticRenderFns } from "./AdvancedTempsAndFans.vue?vue&type=template&id=0af3596a&"
import script from "./AdvancedTempsAndFans.vue?vue&type=script&lang=js&"
export * from "./AdvancedTempsAndFans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports